import styled from 'styled-components'

export const Wrapper = styled.div`
  .ReactTable .rt-thead {
    overflow-y: auto !important;
  }

  font-size: 0.7rem;
  max-width: 100%;
  width: 100%;
  height: 100%;
  overflow-x: auto;

  .ReactTable .rt-tbody {
    overflow-x: hidden;
  }

  .ReactTable .rt-tr-group {
    cursor: pointer;
  }
`

export const ScrollMessage = styled.p`
  .infinite-scroll-component {
    display:  flex;
    flex-direction: column;
    align-items: center;
  }

  margin: 15px;
  color: rgba(0, 0, 0, 0.2);
`

export const HeaderCell = styled.div`
  white-space: pre-wrap;
  word-break: break-word;
  text-align: center;
`
